import {IntermediatePart} from "../../intermediatePart";

export default class LampFixture extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "lamp_fixture";
    this.partName = "Lamp Fixture";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new LampFixture());
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Globals.LampFixture;
    }
  }
}
